import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { LanguageProvider } from "./context/LanguageContext";
import RegulatoryHomePage from "./components/RegulatoryHomePage";
import AIAgencyPage from "./components/AIAgencyPage";
import DokimasiaPage from "./components/DokimasiaPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import NewsPage from "./components/NewsPage";
import DimosiaDioikisi from "./components/services/DimosiaDioikisi";
import Asfaleia from "./components/services/Asfaleia";
import PolitistikiKlironomia from "./components/services/PolitistikiKlironomia";
import ErevnaAnaptyxi from "./components/services/ErevnaAnaptyxi";
import AthenaPage from "./components/AthenaPage";
import AiEtaireiaEllada from "./components/AiEtaireiaEllada";
import Chatbot from "./components/Chatbot";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <header className="App-header">
        <a
          className="App-link"
          href="https://emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" />
        </a>
        <p className="mt-5">Building something incredible ~!</p>
      </header>
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AIAgencyPage />} />
            <Route path="/regulatory" element={<RegulatoryHomePage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/services/dimosia-dioikisi" element={<DimosiaDioikisi />} />
            <Route path="/services/asfaleia" element={<Asfaleia />} />
            <Route path="/services/politistiki-klironomia" element={<PolitistikiKlironomia />} />
            <Route path="/services/erevna-anaptyxi" element={<ErevnaAnaptyxi />} />
            <Route path="/athena" element={<AthenaPage />} />
            <Route path="/ai-etaireia-ellada" element={<AiEtaireiaEllada />} />
            <Route path="/dokimasia" element={<DokimasiaPage />} />
            <Route path="/home" element={<Home />} />
          </Routes>
          
          {/* Chatbot - appears on all pages */}
          <Chatbot />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;